import React from "react";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  ButtonItem,
} from "devextreme-react/form";

export default class ExportacaoCompleta extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  exportarCompleto() {
    console.log("simulacoes", this.obterSimulacoes());
  }

  render() {
    return (
      <div style={{ padding: "25px" }}>
        
      </div>
    );
  }
}
